import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
} from 'antd';
import { apiRequest } from '../../../../service/apiRequest';
import { showSuccess, showError } from '../../../../components/errorHandler';

const { TextArea } = Input;
const { Option } = Select;


const prefixSelector = (
    <Form.Item name="prefix" noStyle  >
        <Select
            style={{ width: 100, }}
            dropdownStyle={{ borderRadius: 10 }}
        >
            <Option value="91">+91</Option>
            <Option value="977">+977</Option>
            <Option value="94">+94</Option>
            <Option value="7">+7</Option>
        </Select>
    </Form.Item>
);

interface WidthModalProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    initialValues?: {
        width_id?: number;
        width_name?: string;
    } | null;
    isEditMode?: boolean;
}

const WidthModal: React.FC<WidthModalProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);

    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };


    // Handle form submit
    const handleAddwidth = async (values: any) => {
        try {
            const dataVal = {
                width_name: values.width_name,
                ...(initialValues?.width_id && { width_id: initialValues.width_id }),
            };
            const url = isEditMode
                ? 'edit-width'
                : 'add-width';

            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: dataVal,
            });
            console.log(dataVal);

            onCreate(data); // Notify parent about success
            showSuccess(
                isEditMode ? 'Width updated successfully!' : 'Width created successfully!',
            );
            form.resetFields();

            if (isModalClose) {
                onCancel(); // Close modal only if Submit button was clicked (not Submit & Create New)
            }
        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} Width`);
        }
    };

    // When modal opens or mode changes, set/reset form fields accordingly
    useEffect(() => {
        if (visible && isEditMode && initialValues) {
            form.setFieldsValue({
                width_name: initialValues.width_name,
            });
        } else if (visible) {
            form.resetFields();
        }
    }, [visible, isEditMode, initialValues, form]);




    return (
        <Modal
            title={isEditMode ? 'Edit Width' : 'Add New Width'}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            width="90%"
            destroyOnClose
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleAddwidth}
                autoComplete="off"
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <Form.Item
                            name="width_name"
                            className='px-8'
                            label={
                                <span>
                                    Width &nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 255 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the Width Name' },
                                { max: 255, message: 'Maximum 255 characters allowed' },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={255}
                                placeholder="e.g., Width "

                            />
                        </Form.Item>
                    </Col>
                </Row>


                <Form.Item style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Space>
                        <Button onClick={onCancel}>Cancel</Button>
                        {!isEditMode && <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(false)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit & Create New Width
                        </Button>}
                        <Button
                            type="primary"
                            htmlType="submit"
                            onClick={() => setIsModalClose(true)}
                            disabled={isSubmitDisabled()}
                        >
                            Submit
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default WidthModal;
